import React from 'react';
import './ProductIntro.css';

const ProductIntro = ({ onDismiss }) => {
  return (
    <div className="product-intro">
      <button className="product-intro-close" onClick={onDismiss}>×</button>
      <div className="product-intro-content">
        <div className="product-slogan">
          <div className="slogan-line">AI赋能经营决策</div>
          <div className="slogan-line">数据驱动全域增长</div>
        </div>
        <div className="product-description">
          通过AI技术为企业提供精准的经营洞察，一键生成增长答案，做您全域增长的智能大脑，让每一步决策都领先未来！
        </div>
      </div>
    </div>
  );
};

export default ProductIntro;

